import service from '@api/config'

// 获取信用积分及星级
export const getScores = (data) => {
  return service.request({
    url: `/user/getScores`,
    method: 'post',
    data: data
  })
}

// 获取项目评价积分明细
export const getScoreDetails = (data) => {
  return service.request({
    url: `/user/getScoreDetails`,
    method: 'post',
    data: data
  })
}
